
import { hqdbService } from "@/service";
import { ref, computed, defineComponent, PropType, reactive, toRefs, watch } from "vue";
import { UserInfo } from "./Index.vue";

interface State {
  list: UserInfo[];
  loading: boolean;
  finished: boolean;
  page: number;
  checked: UserInfo[];
  customerChecked: string[];
}

export default defineComponent({
  name: "Customer",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Array as PropType<UserInfo[]>,
      required: true
    },
    ids: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { multiple, modelValue, ids } = toRefs(props);
    const state = reactive<State>({
      list: [],
      loading: false,
      finished: false,
      page: 1,
      checked: [],
      customerChecked: []
    });
    watch(
      () => modelValue.value,
      now => {
        if (now.length == 0) {
          state.checked = [];
          state.customerChecked = [];
        }
      }
    );
    const search_value = ref("");
    const checkedIdList = computed(() => state.checked.map(item => item.id));

    const onLoad = async () => {
      try {
        const { data } = await hqdbService.subUserLists({
          user_type: "3",
          page: state.page,
          search_name: search_value.value,
          "where_or[stores_ids]": ids.value
        });
        state.list.push(...data.data);
        state.loading = false;
        state.finished = false;
        state.page++;
        if (state.list.length >= data.total) {
          state.finished = true;
        }
      } catch (error) {
        console.log(error);
        state.list = [];
        state.finished = true;
      }
    };
    const onClickTitle = (id: string) => {
      const index = state.customerChecked.findIndex(item => item === id);
      if (index === -1) {
        state.customerChecked.push(id);
      } else {
        state.customerChecked.splice(index, 1);
      }
    };
    const onClick = (user: UserInfo) => {
      if (!multiple.value) {
        state.checked = [user];
      } else {
        const index = state.checked.findIndex(item => item.id === user.id);
        if (index === -1) {
          state.checked.push(user);
        } else {
          state.checked.splice(index, 1);
        }
      }
      emit("update:modelValue", state.checked);
    };
    const onSearch = () => {
      state.page = 1;
      state.list = [];
      onLoad();
    };

    onSearch();

    return { search_value, state, onLoad, onSearch, onClick, checkedIdList, onClickTitle };
  }
});
